module.exports = __webpack_public_path__ + "static/media/image6.cc915ae3.png";